module.exports = __webpack_public_path__ + "static/sharks-in-the-time-of-saviours-b3f2249b6fe5e8234756d6abb1797406.jpg";